// import axios from '../../utils/request'
// import axios from 'axios'
import { getJsonObj } from '../../../utils'
import { request, utils } from 'ynf-core-engine';
const { EventEmitter } = utils;
const eventEmitter = new EventEmitter();

/**
 * getFetchRefData请求批量处理
 * @param {*} data
 * @param {*} params
 * @returns
 */
const getRefDataTimer = {}; // timer缓存
const getRefDataCache = {}; // data缓存
async function getFetchRefData (data, params) {
  return new Promise((resolve, reject) => {
    const copyData = JSON.parse(JSON.stringify(data));
    const conditionKey = copyData?.treeCondition ? 'treeCondition' : 'condition';
    if (copyData[conditionKey]?.simpleVOs?.[0]?.conditions) {
      delete copyData[conditionKey].simpleVOs[0].conditions;
    }
    const source = JSON.stringify({ params, data: copyData });
    // 订阅事件
    eventEmitter.once(source, 'getRefDataResolve', resolve);
    eventEmitter.once(source, 'getRefDataReject', reject);

    if (!getRefDataCache[source]) {
      getRefDataCache[source] = data;
    } else {
      // 合并conditions请求参数
      const conditions = getRefDataCache[source][conditionKey]?.simpleVOs?.[0]?.conditions;
      const newConditions = data[conditionKey]?.simpleVOs?.[0]?.conditions;
      if (conditions) {
        conditions.splice(conditions.length, 0, ...newConditions);
      }
    }
    // 防抖处理
    clearTimeout(getRefDataTimer[source]);
    getRefDataTimer[source] = setTimeout(() => {
      const data = getRefDataCache[source];
      delete getRefDataTimer[source];
      delete getRefDataCache[source];
      request({
        url: `/mdf-node/qtmProxy/ypd/bill/ref/getRefData`,
        method: 'post',
        withCredentials: true,
        data,
        params
      }).then(res => {
        // 发布 getRefDataResolve 事件
        eventEmitter.emitParallel(source, 'getRefDataResolve', null, res);
        eventEmitter.clear(source, 'getRefDataReject');
      }).catch(error => {
        // 发布 getRefDataReject 事件
        eventEmitter.emitParallel(source, 'getRefDataReject', null, error);
        eventEmitter.clear(source, 'getRefDataResolve');
      })
    }, 100);
  })
}

/**
 * getRefData
 * @param {*} data
 * @param {*} params
 * @returns
 */
async function getRefData (data, params) {
  return request({
    url: `/mdf-node/qtmProxy/ypd/bill/ref/getRefData`,
    method: 'post',
    withCredentials: true,
    data,
    params
  })
}

export default async function requestRefData (requestData, params, referContext) {
  const refData = referContext.props.refData; // 自定义参照数据, 不走接口
  if (refData) {
    const res = typeof refData === 'string' ? getJsonObj(refData) : refData;
    const { code, data, message } = res;
    if (code === 200) {
      return data;
    } else {
      utils.message.danger(`${lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00034', '获取列表数据接口失败:')}${message}`);
    }
  } else {
    try {
      const content = referContext.props.pageStore?.query
      const res = await getRefData(requestData, { ...content, ...params });
      return res.data;
    } catch (error) {
      utils.message.danger(`${lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00034', '获取列表数据接口失败:')}${error?.message}`);
    }
  }
}
